import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var registerRoute = [{
  path: "register",
  name: "register",
  component: function component() {
    return import("./register.vue");
  }
}];